import { computed, type ComputedRef } from "vue";

/**
 * True once the category tree for the current locale is in the store.
 * Gates category carousels: their slides link through the tree, so without it
 * every slide would link to "/".
 */
export const useHasCategoryTree = (): ComputedRef<boolean> => {
	const { locale } = useI18n();
	const categoryStore = useCategoryStore();
	return computed(() => !!categoryStore.getCategoryTree[locale.value]?.length);
};
